import { getDisplayName, splitTaskReferenceName, generateRandomText } from "./helpers";
import { TaskType } from "./constants";


/* create a generic node */
export function createTaskNode(
    displayName,
    name,
    refPrefix,
    type,
    joinTaskType = null,
    joinRef = null,
    randomRefText = null
) {
    displayName = getDisplayName(displayName);
    let randomText = "";
    let taskObj = null;

    if (
        // (type === TaskType.EndOfSwitch ||
        //   type === TaskType.Join ||
        //   type === TaskType.EndOfDoWhile) &&
        (name === TaskType.EndOfSwitch ||
            name === TaskType.EndOfForkJoin ||
            name === TaskType.EndOfDoWhile ||
            name === TaskType.EndTriggerApproval ||
            name === TaskType.EndSubWorkflow) &&
        randomRefText
    ) {
        randomText = splitTaskReferenceName(randomRefText);
    } else {
        randomText = generateRandomText();
    }

    // TaskType.Simple,
    // splitTaskReferenceName(forkSimpleNode.taskReferenceName),
    // forkJoinNode.taskReferenceName

    taskObj = {
        inputParameters: {},
        displayName: `${displayName.split("_").join(" ")}`,
        name: `${name}`,
        taskReferenceName: `${refPrefix}_${randomText}_ref`,
        type: `${type}`,
    };
    if (refPrefix === TaskType.EndOfSwitch && joinTaskType && joinRef) {
        taskObj["joinOn"] = [`${joinTaskType}_${joinRef}_ref`];
    }
    return taskObj;
}

/* create a switch component  */
export function createSwitchComponent(newTask) {
    /* Create switch node */
    let switchNode = createTaskNode(
        newTask.task,
        newTask.task,
        newTask.task,
        TaskType.Switch
    );
    if (switchNode == null) return;
    switchNode["inputParameters"] = {};
    switchNode["defaultCase"] = [];

    /* Create default node */
    let defaultNode = createTaskNode(
        TaskType.Default,
        TaskType.Default,
        TaskType.Default,
        TaskType.Label
    );
    if (defaultNode == null) return;
    switchNode.defaultCase.push(defaultNode);

    /* Add default case to default node */
    // let defaultCase = createTaskNode(
    //     TaskType.Simple,
    //     TaskType.Simple,
    //     TaskType.Simple,
    //     TaskType.Simple
    // );
    // if (defaultCase == null) return;
    // switchNode.defaultCase.push(defaultCase);
    // Default node removed from Switch task
    /* Add end of switch */
    let endOfSwitchNode = createTaskNode(
        TaskType.EndOfSwitch,
        TaskType.EndOfSwitch,
        TaskType.EndOfSwitch,
        TaskType.Label,
        TaskType.Simple,
        splitTaskReferenceName(defaultNode.taskReferenceName),
        switchNode.taskReferenceName
    );
    endOfSwitchNode["inputParameters"] = {};

    return { switchNode, endOfSwitchNode };
}

/* create a fork component  */
export function createForkComponent() {
    /* Create fork node */
    let forkJoinNode = createTaskNode(
        TaskType.ForkJoin,
        TaskType.ForkJoin,
        TaskType.ForkJoin,
        TaskType.ForkJoin
    );
    if (forkJoinNode == null) return;
    forkJoinNode["inputParameters"] = {};
    forkJoinNode["defaultCase"] = [];
    forkJoinNode["forkTasks"] = [[]];

    /* Create fork branch node */
    let forkBranchNode = createTaskNode(
        TaskType.ForkBranch + " PATH 1",
        TaskType.ForkBranch,
        TaskType.ForkBranch,
        TaskType.Label
    );
    if (forkBranchNode == null) return;
    forkJoinNode.forkTasks[0].push(forkBranchNode);

    /* Add default case to fork branch node */
    let forkSimpleNode = createTaskNode(
        TaskType.Simple,
        TaskType.Simple,
        TaskType.Simple,
        TaskType.Simple
    );
    if (forkSimpleNode == null) return;
    forkJoinNode.forkTasks[0].push(forkSimpleNode);

    let joinNode = createTaskNode(
        TaskType.JoinTask,
        TaskType.JoinTask,
        TaskType.JoinTask,
        TaskType.JoinTask,
        TaskType.JoinTask
        // splitTaskReferenceName(forkSimpleNode.taskReferenceName),
        // forkJoinNode.taskReferenceName
    );

    /* Add join node label */
    let joinLabelNode = createTaskNode(
        TaskType.EndOfForkJoin,
        TaskType.EndOfForkJoin,
        TaskType.EndOfForkJoin,
        TaskType.Label,
        joinNode.taskReferenceName,
        splitTaskReferenceName(joinNode.taskReferenceName),
        forkJoinNode.taskReferenceName
    );
    joinNode["inputParameters"] = {};
    joinNode["forkTasks"] = forkJoinNode.forkTasks;
    joinNode["joinOn"] = [];
    return { forkJoinNode, joinNode, joinLabelNode };
}

/* create a while component */
export function createDoWhileComponent() {
    /* Create while node */
    let doWhileNode = createTaskNode(
        TaskType.DoWhile,
        TaskType.DoWhile,
        TaskType.DoWhile,
        TaskType.DoWhile
    );
    if (doWhileNode == null) return;
    doWhileNode["inputParameters"] = {};
    doWhileNode["loopOver"] = [];
    /* Create while body node */
    let doWhileBodyNode = createTaskNode(
        TaskType.Simple,
        TaskType.Simple,
        TaskType.Simple,
        TaskType.Simple
    );
    if (doWhileBodyNode == null) return;
    doWhileNode.loopOver.push(doWhileBodyNode);
    /* Create end of while node */
    let endOfDoWhileNode = createTaskNode(
        TaskType.EndOfDoWhile,
        TaskType.EndOfDoWhile,
        TaskType.EndOfDoWhile,
        TaskType.Label,
        TaskType.Simple,
        splitTaskReferenceName(doWhileNode.taskReferenceName),
        doWhileNode.taskReferenceName
    );

    return { doWhileNode, endOfDoWhileNode };
}

export function createSubWorkflowComponent() {

    let subWorkflowNode = createTaskNode(
        TaskType.SubWorkflow,
        TaskType.SubWorkflow,
        TaskType.SubWorkflow,
        TaskType.SubWorkflow
    );
    if (!subWorkflowNode) return;

    return subWorkflowNode;
}

/*Create a Trigger Approval component*/
export function createTriggerApprovalComponent(switchTaskDetails) {
    /* Create start trigger node */
    let startTriggerApprovalNode = createTaskNode(
        TaskType.StartTriggerApproval,
        TaskType.StartTriggerApproval,
        TaskType.StartTriggerApproval,
        TaskType.Label
    );
    if (!startTriggerApprovalNode) return;


    // create triggerApprovalNode
    let triggerApprovalNode = createTaskNode(
        TaskType.TriggerApproval,
        TaskType.TriggerApproval,
        TaskType.TriggerApproval,
        TaskType.TriggerApproval
    );
    if (!triggerApprovalNode) return;


    // create fetchApprovalNode
    let fetchApprovalNode = createTaskNode(
        TaskType.FetchApproval,
        TaskType.FetchApproval,
        TaskType.FetchApproval,
        TaskType.FetchApproval
    );
    if (!fetchApprovalNode) return;


    // create switchNode
    const switchObj = { task: TaskType.Switch, type: "SYSTEM" };
    const { switchNode, endOfSwitchNode } = createSwitchComponent(
        switchObj,
        switchTaskDetails
    );
    if (!switchNode) return
    /* Create end trigger node */
    let endTriggerApprovalNode = createTaskNode(
        TaskType.EndTriggerApproval,
        TaskType.EndTriggerApproval,
        TaskType.EndTriggerApproval,
        TaskType.Label,
        null,
        null,
        startTriggerApprovalNode.taskReferenceName
    );
    if (!endTriggerApprovalNode) return;


    return { startTriggerApprovalNode, triggerApprovalNode, fetchApprovalNode, switchNode, endOfSwitchNode, endTriggerApprovalNode };
}

